module.exports = __webpack_public_path__ + "static/media/pulse.1319bdcb.png";